import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
    
export class ComSubService {
  public showLoading: boolean = false;
  public showLoadingSync = new BehaviorSubject<boolean>(false);
  public showShdrInfoSub = new BehaviorSubject<boolean>(false);
  constructor() { }

  /** open: use to control open showloading when loading is closed */
  public refreshLoading(flag: boolean, open: boolean = false) {
    if (!open || (open && !this.showLoading)) { 
      this.showLoading = flag;
      this.showLoadingSync.next(flag);
    }
  }

  public clearComSubscribe() {
    this.showLoadingSync.unsubscribe();
    this.showShdrInfoSub.unsubscribe();
  }

}
